module.exports = __webpack_public_path__ + "img/project_yyyy_1.27e85d67.png";